var _a;
import { __spreadArray } from "tslib";
import { BiEventType } from './constants';
// these are common for all events, you can omit them as they will be automatically mixed in
var commonFields = {
    requiredFields: [
        'evid',
        'client_id',
        'platform',
        'referer',
        'requestid',
        'url',
        'version',
    ],
    optionalFields: ['uuid', 'view', 'component', 'notification_message_id'],
};
/** @deprecated please use the new event interfaces instead */
var eventRegistry = (_a = {},
    _a[BiEventType.GALLECTION_SEARCH_SUBMIT] = {
        requiredFields: ['search_text'],
        optionalFields: [],
    },
    _a[BiEventType.CLICK_SOCIAL_LINK] = {
        requiredFields: ['typeid', 'itemid', 'widgetname', 'social_share'],
        optionalFields: [],
    },
    _a[BiEventType.USERNAME_CLICK] = {
        requiredFields: ['itemid', 'typeid'],
        optionalFields: [
            'creatorid',
            'attribution',
            'sectionid',
            'sectionname',
            'section_typeid',
            'sectiontype',
            'sectionrank',
            'widgetname',
            'rank',
            'notification_sender_id',
            'notification_type',
            'sort_type',
            'reason_shown',
        ],
    },
    _a[BiEventType.THUMB_FAVE] = {
        requiredFields: ['itemid', 'typeid', 'creatorid'],
        optionalFields: [
            'attribution',
            'sectionid',
            'sectionname',
            'section_typeid',
            'sectiontype',
            'sectionrank',
            'widgetname',
            'rank',
            'sort_type',
            'reason_shown',
        ],
    },
    _a[BiEventType.THUMB_CLICK_UNFAVE] = {
        requiredFields: ['itemid', 'typeid', 'creatorid'],
        optionalFields: [
            'attribution',
            'sectionid',
            'sectionname',
            'section_typeid',
            'sectiontype',
            'sectionrank',
            'widgetname',
            'rank',
            'sort_type',
            'reason_shown',
        ],
    },
    _a[BiEventType.THUMB_CLICK_COMMENT] = {
        requiredFields: ['typeid', 'itemid', 'creatorid'],
        optionalFields: [
            'attribution',
            'sectionid',
            'sectionname',
            'section_typeid',
            'sectiontype',
            'sectionrank',
            'widgetname',
            'rank',
            'sort_type',
            'reason_shown',
        ],
    },
    _a[BiEventType.SEE_ALL_CLICK] = {
        requiredFields: [],
        optionalFields: [
            'attribution',
            'creatorid',
            'typeid',
            'itemid',
            'sectionid',
            'sectionname',
            'section_typeid',
            'sectiontype',
            'sectionrank',
            'widgetname',
            'rank',
            'sort_type',
            'reason_shown',
        ],
    },
    _a[BiEventType.EDIT_WIDGET_CLICK] = {
        requiredFields: ['widgetname', 'widgetzone'],
        optionalFields: [],
    },
    _a[BiEventType.REMOVE_WIDGET_CLICK] = {
        requiredFields: ['widgetname', 'widgetzone'],
        optionalFields: [],
    },
    _a[BiEventType.MOVE_WIDGET_CLICK] = {
        requiredFields: ['widgetname', 'widgetzone', 'direction'],
        optionalFields: [],
    },
    _a[BiEventType.ADD_WIDGET_CLICK] = {
        requiredFields: [],
        optionalFields: [],
    },
    _a[BiEventType.ADD_WIDGET] = {
        requiredFields: ['widgetname', 'widgetzone'],
        optionalFields: [],
    },
    _a[BiEventType.USERNAME_HOVER_TO_OPEN] = {
        requiredFields: [],
        optionalFields: [
            'attribution',
            'creatorid',
            'typeid',
            'itemid',
            'sectionid',
            'sectionname',
            'section_typeid',
            'sectiontype',
            'sectionrank',
            'widgetname',
            'rank',
            'sort_type',
            'reason_shown',
        ],
    },
    _a[BiEventType.CAROUSEL_ARROW_CLICK] = {
        requiredFields: [],
        optionalFields: [
            'typeid',
            'itemid',
            'direction',
            'scroll_pct',
            'sectionid',
            'section_typeid',
            'sectionname',
            'sectiontype',
            'sectionrank',
            'widgetname',
        ],
    },
    _a[BiEventType.TOPICS_VIEW_ALL_CLICK] = {
        requiredFields: ['is_expanding'],
        optionalFields: [],
    },
    _a[BiEventType.POLL_VOTE] = {
        requiredFields: ['pollid'],
        optionalFields: ['rank', 'sort_type'],
    },
    _a[BiEventType.POST_FROM_FEED] = {
        requiredFields: ['is_from_textbox', 'typeid'],
        optionalFields: ['sort_type'],
    },
    _a[BiEventType.SWITCH_POST_TYPE] = {
        requiredFields: ['switch_to'],
        optionalFields: [],
    },
    _a[BiEventType.NEXT_POST] = {
        requiredFields: ['itemid', 'typeid'],
        optionalFields: ['creatorid', 'rank', 'sort_type'],
    },
    _a[BiEventType.CONTENT_NAVBAR_CLICK] = {
        requiredFields: ['link_name'],
        optionalFields: ['indicator'],
    },
    _a[BiEventType.SORT_TYPE_SELECT] = {
        requiredFields: ['menu_selection', 'dropdown_type'],
        optionalFields: ['sectionname'],
    },
    _a[BiEventType.SEARCH_TAG_CLICK] = {
        requiredFields: ['tag_text', 'is_selected'],
        optionalFields: ['link_url'],
    },
    _a[BiEventType.PROFILE_NAV_BAR] = {
        requiredFields: ['link_name', 'itemid', 'typeid'],
        optionalFields: [],
    },
    _a[BiEventType.COMMENT_ACTION] = {
        requiredFields: ['itemid', 'typeid', 'commentid', 'commenterid'],
        optionalFields: [
            'widgetname',
            'sectionname',
            'menu_item_name',
            'is_comment_thread',
        ],
    },
    _a[BiEventType.CLICK_VIEW_REPLY_TO_COMMENT] = {
        requiredFields: ['itemid', 'typeid', 'commentid', 'commenterid'],
        optionalFields: [],
    },
    _a[BiEventType.CLICK_COMMENT_LIKE] = {
        requiredFields: [
            'is_liking',
            'itemid',
            'typeid',
            'commentid',
            'commenterid',
        ],
        optionalFields: ['is_comment_thread', 'notification_type'],
    },
    _a[BiEventType.SEND_NOTE_CLICK] = {
        requiredFields: ['recipientid', 'sectionname'],
        optionalFields: [
            'typeid',
            'itemid',
            'rank',
            'sectionid',
            'section_typeid',
            'sectiontype',
            'sectionrank',
            'sort_type',
            'reason_shown',
            'notification_type',
            'notification_sender_id',
        ],
    },
    _a[BiEventType.GIFT_CLICK] = {
        requiredFields: ['recipientid'],
        optionalFields: [],
    },
    _a[BiEventType.GIFT_SELECT_CLICK] = {
        requiredFields: ['recipientid', 'menu_item_name'],
        optionalFields: ['link_url'],
    },
    _a[BiEventType.GALLERY_SEARCH_CLICK] = {
        requiredFields: [],
        optionalFields: ['sectionname', 'typeid', 'itemid'],
    },
    _a[BiEventType.PROFILE_SUB_NAV_BAR] = {
        requiredFields: ['menu_item'],
        optionalFields: ['itemid', 'typeid'],
    },
    _a[BiEventType.PROFILE_ABOUT_SIDEBAR] = {
        requiredFields: ['menu_item_name'],
        optionalFields: ['itemid', 'typeid'],
    },
    _a[BiEventType.PROFILE_STATS_SIDEBAR] = {
        requiredFields: ['menu_item_name'],
        optionalFields: ['itemid', 'typeid'],
    },
    _a[BiEventType.PROFILE_SUB_NAV_BAR_TOGGLE] = {
        requiredFields: ['itemid', 'typeid', 'toggle_value'],
        optionalFields: [],
    },
    _a[BiEventType.PROFILE_LOAD_MORE_CLICK] = {
        requiredFields: ['widgetname', 'typeid', 'itemid'],
        optionalFields: ['sectionname'],
    },
    _a[BiEventType.PROFILE_ORDER_COMMISSION] = {
        requiredFields: ['itemid', 'typeid', 'creatorid', 'points'],
        optionalFields: ['sectionname'],
    },
    _a[BiEventType.DONATE_POINTS_CLICK] = {
        requiredFields: ['recipientid', 'widgetname'],
        optionalFields: [],
    },
    _a[BiEventType.DONATION_POOL_SETUP_CONFIRM] = {
        requiredFields: [
            'view',
            'widgetname',
            'donation_goal_points',
            'typeid',
            'itemid',
        ],
        optionalFields: [],
    },
    _a[BiEventType.PROFILE_GALLERY_VIEW_MODE_CLICK] = {
        requiredFields: ['view_mode'],
        optionalFields: [],
    },
    _a[BiEventType.NAVIGATION_ARROW_CLICK] = {
        requiredFields: ['itemid', 'typeid', 'next_itemid', 'direction'],
        optionalFields: ['galleryid'],
    },
    _a[BiEventType.THEATRE_MODE] = {
        requiredFields: ['deviationid', 'viewmode'],
        optionalFields: [],
    },
    _a[BiEventType.FULLSCREEN_MODE] = {
        requiredFields: ['deviationid', 'viewmode'],
        optionalFields: [],
    },
    _a[BiEventType.ZOOM_MODE] = {
        requiredFields: ['deviationid', 'viewmode'],
        optionalFields: [],
    },
    _a[BiEventType.BACK_TO_CLICK] = {
        requiredFields: ['itemid', 'typeid', 'link_url'],
        optionalFields: ['next_itemid', 'next_typeid'],
    },
    _a[BiEventType.GIVE_BADGE_AWARD] = {
        requiredFields: ['sectionname', 'typeid', 'itemid'],
        optionalFields: [],
    },
    _a[BiEventType.CLICK_DOWNLOAD_BUTTON] = {
        requiredFields: ['deviationid', 'ispaiddownload'],
        optionalFields: [],
    },
    _a[BiEventType.DOWNLOAD_NOW_CLICK] = {
        requiredFields: ['deviationid'],
        optionalFields: [],
    },
    _a[BiEventType.START_DOWNLOAD_CLICK] = {
        requiredFields: ['deviationid'],
        optionalFields: [],
    },
    _a[BiEventType.ADD_TO_COLLECTION_DONE_CLICK] = {
        requiredFields: [
            'view',
            'creatorid',
            'typeid',
            'itemid',
            'num_collections',
        ],
        optionalFields: ['sectionname', 'collectionid'],
    },
    _a[BiEventType.ADD_TO_GROUP_FOLDER_SELECT] = {
        requiredFields: ['typeid', 'itemid', 'groupid', 'deviationid'],
        optionalFields: [],
    },
    _a[BiEventType.ADD_TO_GROUP_CLICK] = {
        requiredFields: ['deviationid', 'sectionname'],
        optionalFields: [],
    },
    _a[BiEventType.ADD_TO_GROUP_SELECT] = {
        requiredFields: ['groupid', 'deviationid'],
        optionalFields: [],
    },
    _a[BiEventType.CLICK_COPY] = {
        requiredFields: ['itemid', 'typeid'],
        optionalFields: ['deviationid'],
    },
    _a[BiEventType.BUY_CLICK] = {
        requiredFields: ['deviationid'],
        optionalFields: [],
    },
    _a[BiEventType.GALLERY_PURCHASE] = {
        requiredFields: ['typeid', 'itemid', 'galleryid'],
        optionalFields: [
            'points',
            'widgetname',
            'sectionid',
            'sectionname',
            'section_typeid',
            'authorid',
            'rank',
            'reason_shown',
            'sectionrank',
            'sectiontype',
            'sort_type',
        ],
    },
    _a[BiEventType.CHANGE_BACKGROUND_CLICK] = {
        requiredFields: ['typeid', 'itemid', 'background_id'],
        optionalFields: [],
    },
    _a[BiEventType.DEVIATION_EDIT_CLICK] = {
        requiredFields: ['itemid', 'typeid'],
        optionalFields: [],
    },
    _a[BiEventType.DEVIATION_DELETE_CLICK] = {
        requiredFields: ['typeid', 'itemid'],
        optionalFields: [],
    },
    _a[BiEventType.TAG_CLICK] = {
        requiredFields: ['tag_text', 'link_url'],
        optionalFields: ['tagid'],
    },
    _a[BiEventType.SUBJECT_CLICK] = {
        requiredFields: [
            'view',
            'subject_name',
            'subject_type',
            'itemid',
            'typeid',
        ],
        optionalFields: [],
    },
    _a[BiEventType.LOCATION_CLICK] = {
        requiredFields: ['location_name', 'typeid', 'itemid'],
        optionalFields: [],
    },
    _a[BiEventType.WATCH_SECTION_SELECT] = {
        requiredFields: [],
        optionalFields: ['sectionname', 'is_from_navbar'],
    },
    _a[BiEventType.CHANGE_FEED_MODE] = {
        requiredFields: ['feed_mode', 'previous_feed_mode'],
        optionalFields: ['typeid', 'itemid'],
    },
    _a[BiEventType.NOTIFICATION_CLICK] = {
        requiredFields: ['link_url', 'notification_type'],
        optionalFields: [
            'notification_sender_id',
            'notification_rank',
            'notification_type_id',
            'notification_item_id',
        ],
    },
    _a[BiEventType.NOTIFICATION_GIVE_CLICK] = {
        requiredFields: ['notification_sender_id', 'notification_type'],
        optionalFields: [],
    },
    _a[BiEventType.LIVE_NOTIFICATION_TOGGLE] = {
        requiredFields: ['is_selected'],
        optionalFields: [],
    },
    _a[BiEventType.LIVE_NOTIFICATION_CLICK] = {
        requiredFields: ['is_selected'],
        optionalFields: [],
    },
    _a[BiEventType.LIVE_NOTIFICATION_ACTIVITY_OPTION] = {
        requiredFields: ['is_selected', 'notification_type'],
        optionalFields: ['notification_type_id'],
    },
    _a[BiEventType.WATCH_ITEM_REMOVE_CLICK] = {
        requiredFields: ['itemid', 'typeid', 'rank'],
        optionalFields: [
            'feed_mode',
            'is_grouped',
            'sectionname',
            'sectionid',
            'section_typeid',
            'items_selected_count',
            'notification_sender_id',
            'notification_type',
            'groupid',
            'button_name',
        ],
    },
    _a[BiEventType.NEW_CHAT] = {
        requiredFields: [],
        optionalFields: [
            'notification_sender_id',
            'notification_type',
            'notification_message_id',
        ],
    },
    _a[BiEventType.ENABLE_FLOATING_CHAT] = {
        requiredFields: ['toggle'],
        optionalFields: [],
    },
    _a[BiEventType.ONLINE_MODE] = {
        requiredFields: ['online_mode'],
        optionalFields: [],
    },
    _a[BiEventType.CHAT_MUTE_MODE] = {
        requiredFields: ['mute_mode'],
        optionalFields: [],
    },
    _a[BiEventType.CHAT_DROPDOWN_MENU] = {
        requiredFields: ['chat_uuid', 'menu_item'],
        optionalFields: [],
    },
    _a[BiEventType.CHAT_SELECT] = {
        requiredFields: ['chat_uuid'],
        optionalFields: ['chat_list_type'],
    },
    _a[BiEventType.CHAT_MAX_MIN] = {
        requiredFields: ['chat_uuid', 'is_expanding', 'menu_item'],
        optionalFields: [],
    },
    _a[BiEventType.CHAT_ADD_MEDIA] = {
        requiredFields: ['chat_uuid'],
        optionalFields: [],
    },
    _a[BiEventType.ADD_MEDIA_TYPE] = {
        requiredFields: ['chat_uuid', 'media_type'],
        optionalFields: [],
    },
    _a[BiEventType.CHAT_SEND] = {
        requiredFields: ['chat_uuid'],
        optionalFields: [],
    },
    _a[BiEventType.ADD_USER_TO_CHAT] = {
        requiredFields: ['chat_uuid'],
        optionalFields: [],
    },
    _a[BiEventType.ADD_TO_GROUP_BUTTON] = {
        requiredFields: ['chat_uuid', 'num_users_added', 'added_user_guids'],
        optionalFields: [],
    },
    _a[BiEventType.CHAT_ACTION_CONFIRM] = {
        requiredFields: ['chat_uuid', 'view', 'menu_item'],
        optionalFields: [],
    },
    _a[BiEventType.CLOSE_BANNER_AD] = {
        requiredFields: ['campaignid', 'realestateid'],
        optionalFields: [],
    },
    _a[BiEventType.VIEW_MODE_SELECT] = {
        requiredFields: ['link_name'],
        optionalFields: [],
    },
    _a[BiEventType.VIEW_MORE_NOTIFICATIONS_CLICK] = {
        requiredFields: ['is_grouped', 'feed_mode'],
        optionalFields: ['sectionname', 'groupid'],
    },
    _a[BiEventType.NOTIFICATIONS_SECTION_SELECT] = {
        requiredFields: ['is_from_navbar', 'feed_mode'],
        optionalFields: ['sectionname', 'groupid'],
    },
    _a[BiEventType.ADD_NEW_CONTENT_CLICK] = {
        requiredFields: ['widgetname'],
        optionalFields: [],
    },
    _a[BiEventType.PROFILE_COVER_CLICK] = {
        requiredFields: ['is_update'],
        optionalFields: [],
    },
    _a[BiEventType.PROFILE_WATCH_INTRO] = {
        requiredFields: ['link_url'],
        optionalFields: ['typeid', 'itemid'],
    },
    _a[BiEventType.REDIRECT_TO_LOGIN] = {
        requiredFields: ['referral_info'],
        optionalFields: ['typeid', 'itemid'],
    },
    _a[BiEventType.SIGNUP_SCREEN_SHOW] = {
        requiredFields: [],
        optionalFields: [],
    },
    _a[BiEventType.LOGIN_ON_SIGNUP_CLICK] = {
        requiredFields: [],
        optionalFields: [],
    },
    _a[BiEventType.TERMS_CLICK] = {
        requiredFields: ['user_name_challenge_mode'],
        optionalFields: [],
    },
    _a[BiEventType.POLICY_CLICK] = {
        requiredFields: ['user_name_challenge_mode'],
        optionalFields: [],
    },
    _a[BiEventType.SIGNUP_ON_SIGNUP_CLICK] = {
        requiredFields: [],
        optionalFields: [],
    },
    _a[BiEventType.SIGNUP_SUCCESS] = {
        requiredFields: ['auth_mode'],
        optionalFields: [],
    },
    _a[BiEventType.SIGNUP_ERROR] = {
        requiredFields: ['error_message'],
        optionalFields: [],
    },
    _a[BiEventType.WELCOME_SCREEN_SHOW] = {
        requiredFields: ['auth_mode', 'absent_days', 'is_new_user'],
        optionalFields: [],
    },
    _a[BiEventType.WELCOME_START_CLICK] = {
        requiredFields: ['auth_mode', 'is_new_user'],
        optionalFields: [],
    },
    _a[BiEventType.WELCOME_CHANGE_EMAIL_CLICK] = {
        requiredFields: ['auth_mode', 'is_new_user'],
        optionalFields: [],
    },
    _a[BiEventType.ALMOST_DONE_SHOW] = {
        requiredFields: ['auth_mode'],
        optionalFields: [],
    },
    _a[BiEventType.ALMOST_DONE_CHANGE_ADDRESS_CLICK] = {
        requiredFields: ['auth_mode'],
        optionalFields: [],
    },
    _a[BiEventType.ALMOST_DONE_RESEND_CLICK] = {
        requiredFields: ['auth_mode'],
        optionalFields: [],
    },
    _a[BiEventType.ALMOST_DONE_CLOSE] = {
        requiredFields: ['auth_mode'],
        optionalFields: [],
    },
    _a[BiEventType.VERIFICATION_SUCCESSFUL_BROWSE_ART_CLICK] = {
        requiredFields: [],
        optionalFields: [],
    },
    _a[BiEventType.LOGIN_SCREEN_SHOW] = {
        requiredFields: ['user_name_challenge_mode'],
        optionalFields: [],
    },
    _a[BiEventType.LOGIN_SCREEN_SIGNUP_CLICK] = {
        requiredFields: [],
        optionalFields: [],
    },
    _a[BiEventType.LOGIN_SCREEN_SUBMIT] = {
        requiredFields: ['user_name_challenge_mode'],
        optionalFields: [],
    },
    _a[BiEventType.LOGIN_REMEMBER_CLICK] = {
        requiredFields: ['new_state', 'user_name_challenge_mode'],
        optionalFields: [],
    },
    _a[BiEventType.LOGIN_FORGOT_PASSWORD_CLICK] = {
        requiredFields: ['user_name_challenge_mode'],
        optionalFields: [],
    },
    _a[BiEventType.LOGIN_ERROR] = {
        requiredFields: ['error_message', 'error_type', 'user_name_challenge_mode'],
        optionalFields: [],
    },
    _a[BiEventType.LOGIN_SUCCESS] = {
        requiredFields: ['is_new_user', 'auth_mode'],
        optionalFields: [],
    },
    _a[BiEventType.WELCOME_SCREEN_CLOSE] = {
        requiredFields: ['auth_mode', 'is_new_user'],
        optionalFields: [],
    },
    _a[BiEventType.INTENT_SHOW] = {
        requiredFields: ['auth_mode'],
        optionalFields: [],
    },
    _a[BiEventType.INTENT_OPTION_TOGGLE] = {
        requiredFields: ['auth_mode', 'new_state', 'option'],
        optionalFields: [],
    },
    _a[BiEventType.INTENT_OTHER_DONE] = {
        requiredFields: ['auth_mode', 'other_desc'],
        optionalFields: [],
    },
    _a[BiEventType.INTENT_OTHER_CANCEL] = {
        requiredFields: ['auth_mode'],
        optionalFields: [],
    },
    _a[BiEventType.INTENT_SKIP] = {
        requiredFields: ['auth_mode'],
        optionalFields: [],
    },
    _a[BiEventType.INTENT_SUBMIT] = {
        requiredFields: ['auth_mode'],
        optionalFields: [],
    },
    _a[BiEventType.LOGIN_CAPTCHA_SHOW] = {
        requiredFields: [],
        optionalFields: [],
    },
    _a[BiEventType.CLICK_ON_COMMENTS_TO_START_TYPING] = {
        requiredFields: ['itemid', 'typeid'],
        optionalFields: ['is_comment_thread', 'notification_type'],
    },
    _a[BiEventType.CLICK_REPLY_TO_COMMENT] = {
        requiredFields: ['itemid', 'typeid', 'commenterid', 'commentid'],
        optionalFields: ['is_comment_thread', 'notification_type'],
    },
    _a[BiEventType.LOAD_MORE_COMMENTS_CLICK] = {
        requiredFields: ['itemid', 'typeid'],
        optionalFields: [
            'is_comment_thread',
            'widgetname',
            'is_load_previous',
            'notification_type',
        ],
    },
    _a[BiEventType.COMMENT_BUTTON_CLICK] = {
        requiredFields: ['itemid', 'typeid', 'is_reply'],
        optionalFields: ['is_comment_thread', 'notification_type'],
    },
    _a[BiEventType.WATCH_SUGGESTION_REMOVE_CLICK] = {
        requiredFields: ['itemid', 'typeid', 'feed_mode', 'rank'],
        optionalFields: ['attribution'],
    },
    _a[BiEventType.WATCH_SUGGESTION_SELECT] = {
        requiredFields: ['is_selected', 'friendid', 'rank'],
        optionalFields: [],
    },
    _a[BiEventType.WATCH_SUGGESTION_SELECT_CANCEL] = {
        requiredFields: ['friends'],
        optionalFields: [],
    },
    _a[BiEventType.WATCH_SUGGESTION_WATCH] = {
        requiredFields: ['friends'],
        optionalFields: [],
    },
    _a[BiEventType.WATCH_SUGGESTION_LOAD_MORE] = {
        requiredFields: ['offset'],
        optionalFields: [],
    },
    _a[BiEventType.POPUP_CLICK_ADD_TO_COLLECTION] = {
        requiredFields: ['itemid', 'typeid', 'creatorid', 'sectionname'],
        optionalFields: [],
    },
    _a[BiEventType.MANAGE_WATCHLIST] = {
        requiredFields: ['feed_mode'],
        optionalFields: [],
    },
    _a[BiEventType.WATCH_FILTER_SEARCH_ICON_CLICK] = {
        requiredFields: [],
        optionalFields: [
            'typeid',
            'feed_mode',
            'sectionid',
            'section_typeid',
            'sectionname',
        ],
    },
    _a[BiEventType.WATCH_FILTER_CLOSE_SEARCH_CLICK] = {
        requiredFields: ['typeid', 'feed_mode'],
        optionalFields: [],
    },
    _a[BiEventType.WATCH_FILTER_SELECT_ALL_CLICK] = {
        requiredFields: [],
        optionalFields: [
            'select_all_type',
            'feed_mode',
            'sectionid',
            'section_typeid',
            'sectionname',
        ],
    },
    _a[BiEventType.WATCH_FILTER_TAB_SELECTION] = {
        requiredFields: ['typeid', 'feed_mode'],
        optionalFields: [],
    },
    _a[BiEventType.WATCH_FILTER_SEARCH] = {
        requiredFields: ['search_text', 'typeid', 'feed_mode'],
        optionalFields: [],
    },
    _a[BiEventType.MORE_MENU_CLICK] = {
        requiredFields: [],
        optionalFields: [
            'itemid',
            'typeid',
            'sort_type',
            'reason_shown',
            'rank',
            'feed_mode',
            'sectionid',
            'section_typeid',
            'sectionname',
            'is_grouped',
        ],
    },
    _a[BiEventType.FEED_SORT_ORDER_SELECT] = {
        requiredFields: ['sort_order', 'feed_mode', 'typeid', 'itemid'],
        optionalFields: [],
    },
    _a[BiEventType.COMMENT_CANCEL_CLICK] = {
        requiredFields: ['itemid', 'typeid'],
        optionalFields: ['is_comment_thread'],
    },
    _a[BiEventType.COMMENT_DELETION_UNDO] = {
        requiredFields: ['commenterid', 'commentid', 'itemid', 'typeid'],
        optionalFields: ['is_comment_thread'],
    },
    _a[BiEventType.COMMENT_EDIT_CLICK] = {
        requiredFields: ['commentid', 'itemid', 'typeid'],
        optionalFields: ['is_comment_thread'],
    },
    _a[BiEventType.WATCH_POPUP_SELECT_ALL] = {
        requiredFields: ['feed_mode'],
        optionalFields: [],
    },
    _a[BiEventType.WATCH_POPUP_SELECT_NONE] = {
        requiredFields: ['feed_mode'],
        optionalFields: [],
    },
    _a[BiEventType.WATCH_GROUP_BY_ARTIST_CLICK] = {
        requiredFields: ['is_grouped', 'sectionname', 'feed_mode'],
        optionalFields: ['groupid'],
    },
    _a[BiEventType.WATCH_POPUP_UNDO_REMOVAL] = {
        requiredFields: ['undo_action'],
        optionalFields: ['feed_mode', 'items_selected_count', 'is_grouped'],
    },
    _a[BiEventType.WATCH_VIEW_ALL_BY_ARTIST] = {
        requiredFields: ['typeid', 'itemid', 'rank'],
        optionalFields: ['feed_mode', 'sectionname'],
    },
    _a[BiEventType.WATCH_POPUP_SAVE] = {
        requiredFields: ['feed_mode', 'items_selected_count'],
        optionalFields: ['groupid'],
    },
    _a[BiEventType.WATCH_POPUP_REMOVE] = {
        requiredFields: ['feed_mode', 'items_selected_count'],
        optionalFields: ['groupid'],
    },
    _a[BiEventType.WATCH_POPUP_CLOSE] = {
        requiredFields: ['feed_mode'],
        optionalFields: ['groupid'],
    },
    _a[BiEventType.WATCH_DEVIATION_SELECT] = {
        requiredFields: ['feed_mode'],
        optionalFields: [
            'sectionname',
            'is_grouped',
            'typeid',
            'itemid',
            'rank',
            'groupid',
            'notification_type',
            'notification_sender_id',
            'items_selected_count',
        ],
    },
    _a[BiEventType.WATCH_DEVIATION_DESELECT] = {
        requiredFields: ['feed_mode'],
        optionalFields: [
            'sectionname',
            'is_grouped',
            'typeid',
            'itemid',
            'rank',
            'groupid',
            'notification_type',
            'notification_sender_id',
            'items_selected_count',
        ],
    },
    _a[BiEventType.WATCH_CONFIRM_REMOVAL] = {
        requiredFields: ['is_grouped', 'removal_confirmed'],
        optionalFields: [
            'typeid',
            'itemid',
            'groupid',
            'rank',
            'sectionname',
            'section_typeid',
            'sectionid',
            'notification_type',
            'items_selected_count',
            'notification_sender_id',
            'feed_mode',
        ],
    },
    _a[BiEventType.WIX_PORTFOLIO_CREATE_CLICK] = {
        requiredFields: [],
        optionalFields: ['sectionname', 'widgetname', 'galleryid'],
    },
    _a[BiEventType.WIX_PORTFOLIO_GET_STARTED_CLICK] = {
        requiredFields: ['is_wix_user'],
        optionalFields: ['is_mobile_landing'],
    },
    _a[BiEventType.WIX_PORTFOLIO_FORM_BACK_CLICK] = {
        requiredFields: ['step_number'],
        optionalFields: [],
    },
    _a[BiEventType.WIX_PORTFOLIO_FORM_NEXT_CLICK] = {
        requiredFields: ['step_number'],
        optionalFields: [
            'was_changed_title',
            'was_changed_bio',
            'galleryid',
            'was_changed_gallery',
            'was_changed_description',
            'was_changed_social',
        ],
    },
    _a[BiEventType.WIX_PORTFOLIO_KIT_NEXT_CLICK] = {
        requiredFields: ['theme_selected', 'was_changed_theme'],
        optionalFields: ['rank'],
    },
    _a[BiEventType.WIX_PORTFOLIO_CLOSE_USER_PROFILE_CTA] = {
        requiredFields: [],
        optionalFields: ['widgetname'],
    },
    _a[BiEventType.WIX_PORTFOLIO_PREVIEW_EDIT_CLICK] = {
        requiredFields: [],
        optionalFields: ['galleryid', 'sectionname', 'widgetname', 'button_type'],
    },
    _a[BiEventType.SELECT_BACKGROUND] = {
        requiredFields: ['typeid', 'itemid', 'background_id'],
        optionalFields: [],
    },
    _a[BiEventType.CLOSE_BACKGROUND_SELECTION_MODAL] = {
        requiredFields: ['typeid', 'itemid', 'background_id'],
        optionalFields: [],
    },
    _a[BiEventType.WATCH_MENU_ITEM_SELECTION] = {
        requiredFields: ['typeid', 'itemid', 'rank', 'sectionname', 'menu_item'],
        optionalFields: ['sort_type', 'feed_mode', 'is_grouped'],
    },
    _a[BiEventType.USER_OR_GROUP_FEED_SELECT] = {
        requiredFields: ['typeid', 'itemid'],
        optionalFields: [
            'feed_mode',
            'sectionid',
            'section_typeid',
            'sectionname',
            'indicator',
            'is_birthday',
        ],
    },
    _a[BiEventType.BUY_CORE_BUTTON] = {
        requiredFields: ['referral_info'],
        optionalFields: ['itemid', 'typeid', 'background_id'],
    },
    _a[BiEventType.DELETE_DEVIATION_CONFIRM_CLICK] = {
        requiredFields: ['itemid', 'typeid'],
        optionalFields: [],
    },
    _a[BiEventType.BUY_CORE_BUTTON_CLICK] = {
        requiredFields: [
            'give_core_or_become_core',
            'membershiplength',
            'membershiptypeid',
        ],
        optionalFields: [],
    },
    _a[BiEventType.PACKAGE_PICKER_CLICK] = {
        requiredFields: ['button_type', 'core_type', 'give_core_or_become_core'],
        optionalFields: [],
    },
    _a[BiEventType.USER_SYMBOL_CLICK] = {
        requiredFields: ['itemid', 'typeid', 'symbol'],
        optionalFields: [
            'attribution',
            'rank',
            'sectionname',
            'sectionid',
            'section_typeid',
            'sectiontype',
            'sectionrank',
            'sort_type',
            'reason_shown',
        ],
    },
    _a[BiEventType.USERS_SYMBOL_LEARN_MORE_CLICK] = {
        requiredFields: ['link_name', 'link_url'],
        optionalFields: ['rank'],
    },
    _a[BiEventType.STATS_CHANGE_LEVEL_CLICK] = {
        requiredFields: [
            'time_period',
            'typeid',
            'itemid',
            'is_viewing_same_option',
        ],
        optionalFields: [],
    },
    _a[BiEventType.STATS_OVERVIEW_TAB_CLICK] = {
        requiredFields: [
            'typeid',
            'creatorid',
            'stat_name',
            'rank',
            'sectionname',
            'time_period',
            'is_viewing_same_option',
        ],
        optionalFields: [],
    },
    _a[BiEventType.STATS_TABLE_SORT_CLICK] = {
        requiredFields: [
            'typeid',
            'creatorid',
            'stat_name',
            'rank',
            'sectionname',
            'time_period',
            'is_viewing_same_option',
        ],
        optionalFields: [],
    },
    _a[BiEventType.ELNINO_VIEW] = {
        requiredFields: ['typeid', 'itemid', 'rank'],
        optionalFields: [],
    },
    _a[BiEventType.COMMISSION_ORDER_ACCEPTED] = {
        requiredFields: [
            'commissionid',
            'commission_buyerid',
            'feed_mode',
            'points',
        ],
        optionalFields: [],
    },
    _a[BiEventType.COMMISSION_ORDER_DECLINED] = {
        requiredFields: [
            'commissionid',
            'commission_buyerid',
            'feed_mode',
            'points',
        ],
        optionalFields: [],
    },
    _a[BiEventType.GROUP_INVITE_ACCEPTED] = {
        requiredFields: ['notification_sender_id', 'groupid', 'feed_mode'],
        optionalFields: ['notification_type'],
    },
    _a[BiEventType.GROUP_INVITE_DECLINED] = {
        requiredFields: ['notification_sender_id', 'groupid', 'feed_mode'],
        optionalFields: ['notification_type'],
    },
    _a[BiEventType.DEVIATION_TO_GROUP_ACCEPTED] = {
        requiredFields: [
            'deviationid',
            'notification_sender_id',
            'groupid',
            'feed_mode',
        ],
        optionalFields: ['notification_type'],
    },
    _a[BiEventType.DEVIATION_TO_GROUP_DECLINED] = {
        requiredFields: [
            'deviationid',
            'notification_sender_id',
            'groupid',
            'feed_mode',
        ],
        optionalFields: ['notification_type'],
    },
    _a[BiEventType.TAG_MODEL_REQUEST_CONFIRMED] = {
        requiredFields: ['deviationid', 'notification_sender_id', 'feed_mode'],
        optionalFields: ['notification_type'],
    },
    _a[BiEventType.TAG_MODEL_REQUEST_DENIED] = {
        requiredFields: ['deviationid', 'notification_sender_id', 'feed_mode'],
        optionalFields: ['notification_type'],
    },
    _a[BiEventType.NOTIFICATIONS_ITEM_SAVE] = {
        requiredFields: [
            'feed_mode',
            'is_grouped',
            'sectionname',
            'items_selected_count',
            'notification_sender_id',
            'notification_type',
            'items_selected_count',
        ],
        optionalFields: ['groupid'],
    },
    _a[BiEventType.EXPAND_NOTIFICATIONS] = {
        requiredFields: ['feed_mode'],
        optionalFields: ['groupid', 'is_grouped', 'sectionname'],
    },
    _a[BiEventType.TOPICS_ONBOARDING_SHOW] = {
        requiredFields: [],
        optionalFields: [],
    },
    _a[BiEventType.TOPICS_ONBOARDING_SELECT] = {
        requiredFields: [
            'typeid',
            'itemid',
            'topic',
            'is_selected',
            'rank',
            'deviationid',
        ],
        optionalFields: [],
    },
    _a[BiEventType.TOPICS_ONBOARDING_DONE] = {
        requiredFields: ['num_topics_selected'],
        optionalFields: [],
    },
    _a[BiEventType.SELECT_CHAT_LIST] = {
        requiredFields: ['chat_list_type'],
        optionalFields: [],
    },
    _a[BiEventType.CLICK_JOIN] = {
        requiredFields: [],
        optionalFields: ['referral_info'],
    },
    _a[BiEventType.CLICK_LOGIN] = {
        requiredFields: [],
        optionalFields: ['referral_info'],
    },
    _a[BiEventType.CHAT_STATUS] = {
        requiredFields: ['connection_status'],
        optionalFields: [],
    },
    _a[BiEventType.READ_MORE_CLICK] = {
        requiredFields: ['typeid', 'itemid'],
        optionalFields: ['creatorid', 'rank', 'sort_type'],
    },
    _a[BiEventType.BADGE_AWARD_CLICK] = {
        requiredFields: ['badge_type', 'badge_typeid'],
        optionalFields: ['sectionname', 'typeid', 'itemid'],
    },
    _a[BiEventType.BADGE_HELP_CLICK] = {
        requiredFields: [],
        optionalFields: ['sectionname', 'typeid', 'itemid'],
    },
    _a[BiEventType.BADGE_TYPE_SELECT] = {
        requiredFields: ['badge_typeid', 'badge_type'],
        optionalFields: ['sectionname', 'typeid', 'itemid'],
    },
    _a[BiEventType.SEND_CHAT_BUTTON_CLICK] = {
        requiredFields: ['friendid'],
        optionalFields: [
            'sectionname',
            'typeid',
            'itemid',
            'sectionid',
            'section_typeid',
        ],
    },
    _a[BiEventType.DRAG_DEVIATION_TO_CHAT] = {
        requiredFields: ['deviationid'],
        optionalFields: [
            'sectionname',
            'typeid',
            'itemid',
            'creatorid',
            'chat_uuid',
        ],
    },
    _a[BiEventType.NETWORK_BAR_NAV_CLICK] = {
        requiredFields: ['sectionname', 'indicator'],
        optionalFields: ['itemid', 'typeid', 'rank', 'is_expanded'],
    },
    _a[BiEventType.NETWORK_BAR_MENU_ICON] = {
        requiredFields: ['is_expanding', 'indicator'],
        optionalFields: [],
    },
    _a[BiEventType.NETWORK_BAR_3DOTS_OPEN] = {
        requiredFields: ['sectionname', 'indicator'],
        optionalFields: ['itemid', 'typeid', 'rank'],
    },
    _a[BiEventType.NETWORK_BAR_3DOTS_SELECT] = {
        requiredFields: ['sectionname', 'indicator', 'menu_item'],
        optionalFields: ['itemid', 'typeid', 'rank'],
    },
    _a[BiEventType.NETWORK_BAR_SECTION_EXPAND_COLLAPSE] = {
        requiredFields: ['sectionname', 'indicator', 'is_expanding', 'is_expanded'],
        optionalFields: [],
    },
    _a[BiEventType.VIEW_GROUP_NOTIFICATION] = {
        requiredFields: ['sectionname', 'itemid', 'typeid', 'groupid'],
        optionalFields: [],
    },
    _a[BiEventType.MORE_ACTIONS_GROUP_NOTIFICATION] = {
        requiredFields: ['notification_type', 'items_selected_count', 'menu_item'],
        optionalFields: [
            'sectionname',
            'is_grouped',
            'groupid',
            'notification_sender_id',
            'feed_mode',
        ],
    },
    _a[BiEventType.JOIN_GROUP] = {
        requiredFields: ['groupid'],
        optionalFields: ['sectionname'],
    },
    _a[BiEventType.PROFILE_POST_FEED_DROPDOWN] = {
        requiredFields: ['menu_item'],
        optionalFields: [],
    },
    _a[BiEventType.CREDIT_CARD_TOKENIZATION] = {
        requiredFields: [
            'response_has_billing_token',
            'tokenization_http_response_code',
        ],
        optionalFields: [],
    },
    _a[BiEventType.VIEW_AS_VISITOR] = {
        requiredFields: [],
        optionalFields: [],
    },
    _a[BiEventType.GET_MORE_POINTS] = {
        requiredFields: ['widgetname'],
        optionalFields: [],
    },
    _a[BiEventType.GIVE_POINTS_CLICK] = {
        requiredFields: ['points_total', 'sent_personal_message', 'widgetname'],
        optionalFields: [],
    },
    _a[BiEventType.BEGIN_TAKEDOWN_PROCESS] = {
        requiredFields: ['feed_mode', 'sectionname', 'deviationid'],
        optionalFields: [
            'notification_sender_id',
            'notification_item_id',
            'link_name',
            'link_url',
            'notification_type',
        ],
    },
    _a[BiEventType.BUY_IN_POPUP_STORE] = {
        requiredFields: ['deviationid'],
        optionalFields: [],
    },
    _a[BiEventType.PAYMENT_BUTTON_CLICK] = {
        requiredFields: [
            'payment_type',
            'item_total',
            'num_items',
            'give_core_or_become_core',
            'subproductid',
            'is_form_valid',
        ],
        optionalFields: [],
    },
    _a[BiEventType.PAYMENT_TYPE_CLICK] = {
        requiredFields: ['payment_type', 'item_total', 'num_items'],
        optionalFields: [],
    },
    _a[BiEventType.CANCEL_SUBSCRIPTION_CLICK] = {
        requiredFields: ['orderid'],
        optionalFields: [],
    },
    _a[BiEventType.CANCEL_SUBSCRIPTION_CONFIRM] = {
        requiredFields: ['orderid'],
        optionalFields: [],
    },
    _a[BiEventType.TIER_ADD_NEW] = {
        requiredFields: ['is_empty_state_view'],
        optionalFields: ['is_tip_jar', 'widgetname'],
    },
    _a[BiEventType.TIER_UPLOAD_COVER_IMAGE] = {
        requiredFields: [],
        optionalFields: ['typeid', 'itemid'],
    },
    _a[BiEventType.TIER_PREVIEW_CLICK] = {
        requiredFields: ['preview_type'],
        optionalFields: ['typeid', 'itemid'],
    },
    _a[BiEventType.TIER_PUBLISH] = {
        requiredFields: ['display_subscribers', 'access_settings'],
        optionalFields: ['typeid', 'itemid'],
    },
    _a[BiEventType.TIER_UPDATE] = {
        requiredFields: [
            'typeid',
            'itemid',
            'display_subscribers',
            'access_settings',
        ],
        optionalFields: [],
    },
    _a[BiEventType.TIER_SAVE_AS_DRAFT] = {
        requiredFields: ['display_subscribers', 'access_settings'],
        optionalFields: ['typeid', 'itemid'],
    },
    _a[BiEventType.TIER_SAVE_AS_DRAFT_CONFIRM] = {
        requiredFields: ['display_subscribers', 'access_settings'],
        optionalFields: ['typeid', 'itemid'],
    },
    _a[BiEventType.TIER_DELETE] = {
        requiredFields: ['typeid', 'itemid', 'has_subscribers'],
        optionalFields: [],
    },
    _a[BiEventType.TIER_DELETE_CONFIRM] = {
        requiredFields: ['typeid', 'itemid', 'has_subscribers'],
        optionalFields: [],
    },
    _a[BiEventType.TIER_NAVIGATION_SELECT] = {
        requiredFields: ['typeid', 'itemid', 'authorid'],
        optionalFields: [],
    },
    _a[BiEventType.NOTIFICATIONS_OPT_OUT] = {
        requiredFields: ['notification_type', 'deviationid'],
        optionalFields: ['sectionname', 'typeid'],
    },
    _a[BiEventType.TIER_EDIT_CLICK] = {
        requiredFields: ['typeid', 'itemid'],
        optionalFields: ['widgetname'],
    },
    _a[BiEventType.TIER_VIEW_BUTTON] = {
        requiredFields: ['typeid', 'itemid'],
        optionalFields: [],
    },
    _a[BiEventType.VIEW_TIER_UNIQUE] = {
        requiredFields: ['typeid', 'itemid'],
        optionalFields: [
            'referral_info',
            'sectionid',
            'sectionname',
            'section_typeid',
            'sectiontype',
            'sectionrank',
            'rank',
        ],
    },
    _a[BiEventType.VIEW_SUBSCRIPTION_TAB] = {
        requiredFields: ['typeid', 'itemid', 'referral_info'],
        optionalFields: [],
    },
    _a[BiEventType.WATCH_SUB_FILTER_OPEN] = {
        requiredFields: ['filter_name'],
        optionalFields: [],
    },
    _a[BiEventType.TIER_SUBSCRIBE] = {
        requiredFields: ['typeid', 'itemid', 'referral_info'],
        optionalFields: [],
    },
    _a[BiEventType.TIER_UNSUBSCRIBE_CONFIRM] = {
        requiredFields: ['typeid', 'itemid', 'referral_info'],
        optionalFields: [],
    },
    _a[BiEventType.TIER_UPGRADE] = {
        requiredFields: ['typeid', 'itemid'],
        optionalFields: ['upgrade_type'],
    },
    _a[BiEventType.TIER_UNSUBSCRIBE] = {
        requiredFields: ['typeid', 'itemid', 'referral_info'],
        optionalFields: [],
    },
    _a[BiEventType.WATCH_SUB_FILTER_SELECT] = {
        requiredFields: ['filter_name'],
        optionalFields: [],
    },
    _a);
export default function getFieldsForEvent(evid) {
    var registry = eventRegistry[evid];
    if (!registry) {
        return;
    }
    return {
        optionalFields: __spreadArray(__spreadArray([], (registry.optionalFields || []), true), commonFields.optionalFields, true),
        requiredFields: __spreadArray(__spreadArray([], (registry.requiredFields || []), true), commonFields.requiredFields, true),
    };
}
//# sourceMappingURL=eventRegistry.js.map